import * as Api from '@ViewModels';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import {
	AUTOMATION_QUERY_KEYS,
	AUTOMATION_STEP_MUTATION_SCOPE,
	AUTOMATION_TEMPLATE_MUTATION_KEY,
} from '../../queryKeys';

interface Params {
	templateId: string;
	stepId: string;
	outcome: Api.AutomationStepOutcome;
	stepType: Api.AutomationStepType;
	step: Api.IAutomationStep;
	impersonationContext?: Api.IImpersonationContext;
}

export function useAutomationTemplateStepAddConditionalMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.IAutomationStep, variables: Params) => void;
	onError?: (error: Api.IOperationResultNoValue, variables: Params) => void;
} = {}) {
	const userSession = useUserSession();
	const queryClient = useQueryClient();
	return useMutation({
		mutationKey: AUTOMATION_TEMPLATE_MUTATION_KEY,
		scope: AUTOMATION_STEP_MUTATION_SCOPE,
		mutationFn: ({ templateId, stepId, outcome, stepType, step, impersonationContext }: Params) => {
			return userSession.webServiceHelper.callAsync<Api.IAutomationStep>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(templateId)}/Step/${encodeURIComponent(
						stepId
					)}/${encodeURIComponent(outcome)}/${encodeURIComponent(stepType)}`,
					impersonationContext,
				}),
				'POST',
				step
			);
		},
		onError,
		onSuccess: (data, variables) => {
			queryClient.invalidateQueries({ queryKey: AUTOMATION_QUERY_KEYS.template(variables.templateId) });
			onSuccess?.(data, variables);
		},
	});
}
